import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import type { PriceBoxAlignment, PriceBoxSize } from '@sunwebgroup/ui-components'
import { useIntl } from '@/intl'
import { PriceBox } from '@sunwebgroup/ui-components'
import { PriceDetails } from './PriceDetailsLegacy'

/**
 * @deprecated Use PriceInfo instead.
 */
export function PriceInfoLegacy({
  accommodationId,
  departureDateRaw,
  durationRaw,
  mealPlan,
  price,
  priceDiscounts,
  transportType,
  size = 'large',
  align = 'end',
  participants,
  ...rest
}: PriceInfoProps) {
  const intl = useIntl()
  const priceText = intl.formatMessage({ id: 'price_box_price_text' })
  const priceFormatted = intl.formatTruncatedCurrency(price)
  const formattedPriceDiscounts = priceDiscounts
    ? {
        discountPercentage: priceDiscounts.discountPercentage,
        originalPrice: intl.formatCurrency(priceDiscounts.originalPrice),
      }
    : undefined

  return (
    <PriceBox
      {...rest}
      price={priceFormatted}
      priceDiscounts={formattedPriceDiscounts}
      priceBoxText={priceText}
      size={size}
      type="box"
      align={align}
    >
      <PriceDetails
        priceDetailsQueryParams={{
          transportType,
          accommodationId,
          duration: durationRaw,
          mealPlan,
          departureDate: departureDateRaw,
          participants,
        }}
      />
    </PriceBox>
  )
}

export interface PriceInfoProps {
  accommodationId: number
  departureDateRaw?: string
  durationRaw?: number
  mealPlan?: string
  price: number
  priceDiscounts?: {
    discountPercentage: number
    originalPrice: number
  }
  transportType?: string
  size?: PriceBoxSize
  align?: PriceBoxAlignment
  participants?: RoomsParticipantDistribution
}
